import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const getDefaultState = () => {
  return {
    created: null,
    calledCountries: {},
    paymentCount: null,
    firstPaymentDate: null,
    lastPaymentDate: null,
    callCount: null,
    firstCallDate: null,
    lastCallDate: null
  }
}

const state = getDefaultState()

mutations.RESET_STATE = (state) => {
  Object.assign(state, getDefaultState())
}
actions.reset = ({ commit }) => {
  commit('RESET_STATE')
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/statistics/index.js